import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectors } from '../../infrastructure/config';
import { isCaseDataFetch } from '../../store/dataCapture/selectors';
import { fetchCase } from '../../infrastructure/cases/actions';

import ApplicationSubmissionPage from './ApplicationSubmissionPage';

const ApplicationSubmissionSection = memo(function ApplicationSubmissionSection({
  isCaseDataFetch,
  fetchCase
}) {
  useEffect(() => {
    if (!isCaseDataFetch) {
      fetchCase(true);
    }
  }, [fetchCase, isCaseDataFetch]);
  return <ApplicationSubmissionPage />;
});

const actionCreators = {
  fetchCase
};

const mapStateToProps = state => ({
  isCaseDataFetch: isCaseDataFetch(state),
  bankId: selectors.bankId(state)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationSubmissionSection);
